import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { PinIcon } from '@repo/ui/icons'
import { PropsWithChildren } from 'react'

type Props = {
  isHiddenOnMobile?: boolean
}

const InformationBox = ({ children, isHiddenOnMobile = true }: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn('bg-white-hover border border-grey-light rounded-lg  mobile:hidden', {
        'mobile:block': !isHiddenOnMobile
      })}
    >
      <div className="flex items-start w-full px-4 py-3 gap-2">
        <div>
          <PinIcon color={tailwindColors.secondary.DEFAULT} />
        </div>
        {children}
      </div>
    </div>
  )
}

export default InformationBox
